import React, {Fragment, Component} from 'react';
import moment from 'moment';
import ReactTable from 'react-table';
import Modal from 'react-modal';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import MenuCalender from '../menuCalender/menuCalender.jsx';
import ByItemAccordion from '../ByItemAccordion/ByItemAccordion.jsx';
import CalenderCarousel from '../CalenderCarousel/CalenderCarousel.jsx';
import TmExportExcel from '../../../../Misc/tmExportExcel/tmExportExcel';
import { get } from '../../../../../server/actions'
import {showFile,convertTwoDecimalPoint, _addNotification, 
    _addNotificationError,isRegularLunchOrderType, getNotWorkingDays, getSchoolGrades, getSchoolSessions, groupBy} from "../../../../../server/util";
import { orderedMenu, menuItems } from '../mockData/mockData.js';
import MenuOptions from '../../../../Misc/MenuOptions/menuOptions';
import {getReportMenuOptions} from '../../../../Misc/MenuOptions/menuOptionsActions';
import {MealTypesReports,MenuOrderTypes,date_format} from '../../../../../server/constants';
import {required,email,zipValidation,isNumeric,phoneNo} from '../../../../../server/validationMethods'
import { filter } from 'lodash';
const catererView={
    week:'Weekly',
    month:'Monthly'
}
const catererFilterView={
    day:'Day',
    items:'Items'
}
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
class CatererReport extends Component {
    constructor(props){
        super(props);
        this.state={
            filterBy:catererView.week,
            viewBy:catererFilterView.day,
            startDate:moment().startOf('W'),
            endDate:moment().endOf('W'),
            date:moment(),
            mDate:moment(),
            mStartDate:moment().startOf('M'),
            mEndDate:moment().endOf('M'),
            orderedMenu:orderedMenu,
            menuItems:menuItems,
            catererResponse:{},
            openCatererModal:false,
            catererEmail:'',
            mealType:(getReportMenuOptions()[0]||''),
            loading:false,
            dataExport:[] ,
            selectedSession:'All',
            grade:'All',
            gradesBySession:[],
            openCatererModal:false,
            catererEmail:'',
            byDayItemsData:[] ,
            isValidEmail:true,
            error: null
        }
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
        this.bindGradeListBySession();
        this.setWeek();
    }
    openCatererModal=()=>{
        this.setState({openCatererModal:true, catererEmail:''});
    }

    isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
      }
    
    handleChange = event => {
        if (!this.isValidEmail(event.target.value)) {
          this.setState({error: 'Email is invalid'});
        } else {
          this.setState({error: null});
        }
    
        this.setState({catererEmail: event.target.value});
      };

    setWeek = () => {
        const from_date = moment().startOf('Week');
        const to_date = moment().endOf('Week');
        this.setState({ week: from_date.format('MM/DD') + " - " + to_date.format('MM/DD'), 
        date: from_date,
        startDate:from_date,
        endDate:to_date,
        toogle: !this.state.toogle,
     },()=>{
        if(this.state.viewBy==='Day_Items'){
            this.getCatererReport_ByDay_Items(from_date,to_date, false);
        }else{
         this.getCatererReport(from_date,to_date);
        }
         //this.formatCatererReportForExcel(from_date,to_date);
     });
    }
    setMonth = () => {
        this.setState({
        mDate:moment(),
        mStartDate:moment().startOf('M'),
        mEndDate: moment().endOf('M'),
        toogle: !this.state.toogle,
     },()=>{
        if(this.state.viewBy==='Day_Items'){
            this.getCatererReport_ByDay_Items(moment().startOf('M'), moment().endOf('M'), false);
        }else{
         this.getCatererReport(moment().startOf('M'), moment().endOf('M'));
        }
         //this.formatCatererReportForExcel(moment(startDate).startOf('month'),moment(endDate).endOf('month'));
     });
    }
    btnCatererExcelExportOnClick=(e)=>{
        const btn=document.getElementById('btnCatererReportExport');
        if(btn){
            btn.click();
        }
    }
    buildDataFormatForExport=()=>{
        return (
            [{
              columns: [{title: 'DATE'}, {title: 'ITEM'}, {title: 'TYPE'},{title: 'COUNT'}],
              data: this.state.dataExport.map(item => {
                  return [{value: item.date || ''}, {value: item.itemName || ''}, {value: item.mealType || ''}
                  , {value: item.count || ''}]
              })
            }]
          )
    }
    formatCatererReportForExcel=(start,end)=>{
        const mealTypesArray=getReportMenuOptions()||[];
        const dataList=[];
        Promise.all(
            mealTypesArray.map(type=>{
              return this.getCatererReportExcel(start,end,type);
            })            
        ).then((res)=>{
            (res||[]).map((data,i)=>{
                Object.keys((data||{}).resList||{}).map(date=>{
                    Object.keys(((data||{}).resList||{})[date]).map(itm=>{
                        dataList.push({
                            date:date,
                            itemName:itm,
                            mealType:mealTypesArray[i],
                            count:(data.resList||{})[date][itm]||0
                        })
                    })    
                })
            })
            this.setState({dataExport:dataList})
        })
    }
    getCatererReportExcel=(start,end,type)=>{
        if(this.state.viewBy==='Day_Items'){
            return;
        }
        this.setState({loading: true});
        const filterGrades=this.filterGradesBySelection();
        return new Promise((resolve, reject) => {
            let url=`/reports/catererReport?isVersion2=true&menuType=${type}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${start.format('YYYY-MM-DD')}&endDate=${end.format('YYYY-MM-DD')}&access_token=`;
            if(filterGrades.length>0){
                url=`/reports/catererReport?isVersion2=true&menuType=${type}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&grades=${filterGrades.join(',')}&startDate=${start.format('YYYY-MM-DD')}&endDate=${end.format('YYYY-MM-DD')}&access_token=`;
            }
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({loading:false })
            resolve({resList: ((data||{}).dateMealItemCountMap||{})});            
        }).catch(error => {
            this.setState({loading: false});
            reject({resList: []});
            console.log("Loading Menu Failed", error)
        })
    })
    }
    getCatererReport = (start,end) => {
        if(this.state.viewBy==='Day_Items'){
            return;
        }
        this.setState({loading: true});
        const filterGrades=this.filterGradesBySelection();
        if(this.state.mealType===MealTypesReports.LUNCH || this.state.mealType===MealTypesReports.BREAKFAST || this.state.mealType===MealTypesReports.SNACK || this.state.mealType===MealTypesReports.DINNER)
        {
            let url=`/reports/catererReport?isVersion2=true&menuType=${this.state.mealType}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${start.format('YYYY-MM-DD')}&endDate=${end.format('YYYY-MM-DD')}&access_token=`;
            if(filterGrades.length>0){
                url=`/reports/catererReport?isVersion2=true&menuType=${this.state.mealType}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&grades=${filterGrades.join(',')}&startDate=${start.format('YYYY-MM-DD')}&endDate=${end.format('YYYY-MM-DD')}&access_token=`;
            }
            get(url).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({ catererResponse:data.dateMealItemCountMap||{} , loading:false },()=>{
                    this.formatCatererReportForExcel(start,end);
                })
            }).catch(error => {
                this.setState({loading: false});
                console.log("Loading Menu Failed", error)
            })
        }
    }; 
    getCatererReport_ByDay_Items = (start,end, isPdf=false, type) => {
        const {selectedSession}=this.state;
        this.setState({loading: true});
        const filterGrades=this.filterGradesBySelection();
        if(this.state.mealType===MealTypesReports.LUNCH || this.state.mealType===MealTypesReports.BREAKFAST || this.state.mealType===MealTypesReports.SNACK || this.state.mealType===MealTypesReports.DINNER)
        {
            let url=`/reports/v2/catererReport/${sessionStorage.getItem('SchoolId')}/${this.state.mealType}/${isPdf?'pdf':'data'}?isSessionWise=${selectedSession==='All'?false:true}&startDate=${start.format('YYYY-MM-DD')}&endDate=${end.format('YYYY-MM-DD')}&access_token=`;
            if(filterGrades.length>0){
                url=`/reports/v2/catererReport/${sessionStorage.getItem('SchoolId')}/${this.state.mealType}/${isPdf?'pdf':'data'}?isSessionWise=${selectedSession==='All'?false:true}&grades=${filterGrades.join(',')}&startDate=${start.format('YYYY-MM-DD')}&endDate=${end.format('YYYY-MM-DD')}&access_token=`;
            }
            if(type==='Email'){
                url=`/reports/v2/catererReport/${sessionStorage.getItem('SchoolId')}/${this.state.mealType}/pdf?catererEmail=${this.state.catererEmail}&isSessionWise=${selectedSession==='All'?false:true}&startDate=${start.format('YYYY-MM-DD')}&endDate=${end.format('YYYY-MM-DD')}&access_token=`;
                get(url).then((response) => {
                    if (!response.ok) {
                        if(response.status===417){
                            return response.json();
                        }else{              
                            throw Error(response.statusText);
                        }                    
                    }
                    return response.json();                
                }).then(resp=>{
                    if (resp.statusCode === 417) {
                        _addNotificationError(resp.statusMessage,this);
                        throw Error(resp.statusMessage);
                    }else{
                        return resp
                    }
                }).then(data => { 
                    if(data.statusCode==200){
                        _addNotification(data.statusMessage,this);
                        this.setState({openCatererModal:false, catererEmail:'', loading:false});
                    }else{
                        _addNotification(data.errorMessage,this);
                        this.setState({openCatererModal:false, catererEmail:'', loading:false});
                    }
                                     
                }).catch(error => {
                    //_addNotification(error,_props);
                    this.setState({openCatererModal:false, catererEmail:'', loading:false});
                });

            }else{
            get(url).then((response) => {
                if (!response.ok) {
                    if(isPdf){
                        if (response.status === 417) {
                            return response.json();
                        }else{
                        throw Error(response.statusText);
                        }
                    }else{
                        throw Error(response.statusText);
                    }                    
                }
                return isPdf?response: response.json();
            }).then(data => {
                if(isPdf){
                    this.setState({loading: false});
                    if (data.statusCode === 417) {
                        _addNotificationError(data.statusMessage,this);
                        throw Error(data.statusMessage);
                   }else{
                       return data.blob();
                   }
                }else{
                    return data;
                }
            }).then(data => {
                if(isPdf){
                    let filename = "Caterer Reports for "
                    showFile(data,filename);
                }else{
                    this.setState({ byDayItemsData:(data.resp||{}) , loading:false },()=>{
                        this.formatCatererReportForExcel(start,end);
                    })
                }
            }).catch(error => {
                this.setState({loading: false, byDayItemsData:{}});
                console.log("Loading Menu Failed", error)
            });
        }
    }
    };   
    bindWeekItemWiseTable=()=>{
        const {catererResponse, filterBy, viewBy, mDate, date}=this.state;
        if(filterBy===catererView.month && viewBy===catererFilterView.items){
            let items=[];
            Object.keys(catererResponse).map((key,i)=>{                
                const newList= Object.keys(catererResponse[key])||[];
                items=[...items,...newList];
            })
        const finalItems=[...new Set(items)];
        const finalArray=[]
        finalItems.map((item)=>{
            const itemObj={
                item:item,
                orderedMenu:[]
            }
            let orderList=[];
            (Object.keys(catererResponse)||[]).forEach(key=>{
                const itm= catererResponse[key][item]||0;
                if(itm>0)
                {
                    const m=moment(key,'YYYY-MM-DD').month();
                    const y=moment(key,'YYYY-MM-DD').year();
                    const d=moment(key,'YYYY-MM-DD').date();
                    orderList.push({
                        "id" : 2300,
                        "type" : "MEAL",
                        "title" : item,
                        "start" : new Date(y, m, d),
                        "end" : new Date(y, m, d),
                        "desc" : null,
                        "price" : 0,
                        "reducedPrice" : 0,
                        "count":catererResponse[key][item]||0
                    });
                }
            });
            itemObj.orderedMenu=orderList;
            finalArray.push(itemObj);
        })   
        
        return <ByItemAccordion 
            items={finalArray}
            columns={[]} 
            filterBy={filterBy} 
            date={mDate} />
        }else{
        let items=[];
        const cols=[{Header:'Item',accessor:'item', style: {textAlign: 'left'}}];
        Object.keys(catererResponse).map((key,i)=>{
            cols.push({Header:moment(key,'YYYY-MM-DD').format('MM/DD'),
            accessor:key, width:150, style: {textAlign: 'right'}});
            const newList= Object.keys(catererResponse[key])||[];
            items=[...items,...newList];
        })
        cols.push({Header:'Total', accessor:'total', style: {textAlign: 'right'}});
        const finalItems=[...new Set(items)];
        const finalArray=[];
        finalItems.map((item)=>{
            const itemObj={item:item}
            let tot=0;
            Object.keys(catererResponse).map((key,i)=>{
                itemObj[key]= catererResponse[key][item]||0;
                tot=tot+parseInt(convertTwoDecimalPoint((catererResponse[key][item]||0),0));
            });
            itemObj['total']=tot;
            finalArray.push(itemObj);
        });
        console.log(finalArray);  
        
        return <ByItemAccordion 
            items={finalArray}
            columns={cols||[]} 
            filterBy={filterBy} 
            date={date} />
        }
    }
    bindByDayItemTable=()=>{
        const {byDayItemsData }=this.state;
        const styles={
            colBorder:{
                borderTop:'1px solid #ddd', 
                paddingTop:'6px', 
                paddingBottom:'6px'
            },
            dateRow:{
                backgroundColor: '#ea7066',
                color: '#fff'
            },
            totalRow:{
                backgroundColor: 'rgb(210, 215, 212)',
                color: '#757576'
            },
            finalTotRow:{
                backgroundColor: '#b5d56a',
                color: '#ffffff'
            }

        }
        const totalCount=(array=[],key)=>{
            let count=0;
            array.map(itm=>{
                count=count+Number(itm[key])
            });
            return count
        }
        const allTotals=()=>{
            let count=0;
            Object.keys(byDayItemsData).map(date=>{
                (byDayItemsData[date]||[]).map(rec=>{
                    count=count+ Number(rec.count)
                })
            });
            return count;
        }
        return <div className='col-md-12'>
            <div class="panel panel-default">
                <div class="panel-body">
                    {
                        Object.keys(byDayItemsData).length>0?
                    
            <div className="row">
                <div className='col-md-12'>
                    <div className="row">
                    {
                    Object.keys(byDayItemsData).map((date)=>{
                        const itemsGroup=groupBy(byDayItemsData[date],'menuName')||{};
                        let dayWiseTotal=0;
                        return (<Fragment>
                            <div className="col-md-2 " style={{...styles.colBorder, ...styles.dateRow}}><strong>Menu Date :</strong></div>
                            <div className="col-md-10" style={{...styles.colBorder, ...styles.dateRow}}><strong>{moment(date,'YYYY-MM-DD').isValid()?moment(date,'YYYY-MM-DD').format(date_format()):'...'}</strong></div>
                            <div className='col-md-12'>
                                <div className='row'>
                                {
                                    Object.keys(itemsGroup).map(itemName=>{
                                        const items=itemsGroup[itemName]||[];
                                        const items_without_others=items.filter(_itm=>{
                                            return _itm['session']!=='Other'
                                        })||[];
                                        const onlyOther=items.filter(_itm=>{
                                            return _itm['session']==='Other'
                                        })||[]
                                        const itemTotal=totalCount(items,'count');
                                        dayWiseTotal=dayWiseTotal+itemTotal;
                                        return <Fragment>
                                            <div className='col-md-1'  style={styles.colBorder}></div><div className='col-md-11'  style={styles.colBorder}><strong>Item Name :</strong>{itemName}</div>
                                            <div className='col-md-1'  style={styles.colBorder}></div><div className='col-md-11'  style={styles.colBorder}><strong>Desc:</strong>{(items[0]||{}).desc||''}</div>
                                            <div className='col-md-12'>
                                                <div className='row'>
                                                {
                                                    [...items_without_others,...onlyOther].map(itm=>{
                                                        return <Fragment>
                                                            <div className='col-md-4' style={styles.colBorder}></div>
                                                            <div className='col-md-4' style={styles.colBorder}><strong>{itm['session']} :</strong></div>
                                                            <div className='col-md-4' style={styles.colBorder}>{itm.count}</div>
                                                            </Fragment>
                                                    })
                                                }
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-4' style={{...styles.colBorder,...styles.totalRow}}>&nbsp;</div>
                                                    <div className='col-md-4' style={{...styles.colBorder,...styles.totalRow}}><strong>Total :</strong></div>
                                                    <div className='col-md-4' style={{...styles.colBorder,...styles.totalRow}}>{itemTotal}</div>
                                                </div>
                                            </div>
                                        </Fragment>                           
                                    })
                                }</div>
                            </div>
                            <div className="col-md-8 " style={styles.colBorder}><strong>Total :</strong></div>
                            <div className="col-md-4" style={styles.colBorder}><strong>{dayWiseTotal}</strong></div>                                       
                        </Fragment>);
                    })
                }
                </div>
            </div>
            <div className="col-md-8 " style={{...styles.colBorder, ...styles.finalTotRow}}><strong>Total :</strong></div>
            <div className="col-md-4" style={{...styles.colBorder, ...styles.finalTotRow}}><strong>{allTotals()}</strong></div>
        </div>
        :<div className='row'>
            <div className='col-md-12 text-center'>
                <strong>No data found</strong>
            </div>
        </div>
    }
        </div>
    </div>            
</div>
}
    bindWeekDataTable=()=>{
        const {catererResponse}=this.state;
        let items=[];
        const cols=[{Header:'Item',accessor:'item', style: {textAlign: 'center'}}];
        Object.keys(catererResponse||{}).map((key,i)=>{
            cols.push({Header:moment(key,'YYYY-MM-DD').format('MM/DD'),
            accessor:key, width:150, style: {textAlign: 'center'}});
            const newList= Object.keys(catererResponse[key])||[];
            items=[...items,...newList];
        })
        cols.push({Header:'Total', accessor:'total', style: {textAlign: 'center'}});
        const finalItems=[...new Set(items)];
        const finalArray=[]
        finalItems.map((item)=>{
            const itemObj={item:item}
            let tot=0;
            Object.keys(catererResponse).map((key,i)=>{
                itemObj[key]= catererResponse[key][item]||0;
                tot=tot+parseInt(convertTwoDecimalPoint((catererResponse[key][item]||0),0));
            });
            itemObj['total']=tot;
            finalArray.push(itemObj);
        })
        
        return <ReactTable
        data={finalArray}
        columns={cols}
        defaultPageSize={10}
        className="-striped -highlight"
        noDataText='No data found' />
    }
    bindMonthDataTable=()=>{
        const {catererResponse,mDate}=this.state;
        const items=[];
        Object.keys(catererResponse||{}).map((key,i)=>{
            ((Object.keys(catererResponse[key])||{})||[]).forEach(itm=>{
                const m=moment(key,'YYYY-MM-DD').month();
                const y=moment(key,'YYYY-MM-DD').year();
                const d=moment(key,'YYYY-MM-DD').date();
                items.push({
                    "id" : 2300,
                    "type" : "MEAL",
                    "title" : itm,
                    "start" : new Date(y, m, d),
                    "end" : new Date(y, m, d),
                    "desc" : null,
                    "price" : 0,
                    "reducedPrice" : 0,
                    "count":catererResponse[key][itm]||0
                  })
            });
        })
        const _date=new Date(moment(mDate).year(),moment(mDate).month(),moment(mDate).date());
        return <MenuCalender date={_date} orderedMenu={items}
        hiddenDays={getNotWorkingDays()} />
    }
    bindGradeListBySession=()=>{
        const {selectedSession,filterBy, viewBy }=this.state;
        let gradeList=getSchoolGrades(0,false);
        const sessionList=getSchoolSessions(0,false);
        if(selectedSession==='All'){
          this.setState({gradesBySession:gradeList, grade:'All'},()=>{
            if(viewBy==='Day_Items'){
                if(filterBy==='Weekly'){
                    this.getCatererReport_ByDay_Items(this.state.startDate,this.state.endDate, false);}
                else{
                    this.getCatererReport_ByDay_Items(this.state.mStartDate,this.state.mEndDate, false);}
                
            }else{
              if(filterBy==='Weekly'){
                    this.getCatererReport(this.state.startDate,this.state.endDate);}
                else{
                    this.getCatererReport(this.state.mStartDate,this.state.mEndDate);}
            }
          });
        }else{
          const _sessionRec=sessionList.find(session=>{
            return session.session==selectedSession;
          })
          if(_sessionRec){
            this.setState({gradesBySession: gradeList.filter(grade=>{
              return _sessionRec.grades.includes(grade.value);
            }), grade:'All'},()=>{
                if(viewBy==='Day_Items'){
                    if(filterBy==='Weekly'){
                        this.getCatererReport_ByDay_Items(this.state.startDate,this.state.endDate, false);}
                    else{
                        this.getCatererReport_ByDay_Items(this.state.mStartDate,this.state.mEndDate, false);}
                    
                }else{
                if(filterBy==='Weekly'){
                    this.getCatererReport(this.state.startDate,this.state.endDate);}
                else{
                    this.getCatererReport(this.state.mStartDate,this.state.mEndDate);}
                }
              });          
          }else{
            this.setState({gradesBySession:[], grade:'All'},()=>{
                if(viewBy==='Day_Items'){
                    if(filterBy==='Weekly'){
                        this.getCatererReport_ByDay_Items(this.state.startDate,this.state.endDate, false);}
                    else{
                        this.getCatererReport_ByDay_Items(this.state.mStartDate,this.state.mEndDate, false);}
                    
                }else{
                if(filterBy==='Weekly'){
                    this.getCatererReport(this.state.startDate,this.state.endDate);}
                else{
                    this.getCatererReport(this.state.mStartDate,this.state.mEndDate);}
                }
              });
          }
        }        
      }
      filterGradesBySelection=()=>{
        const { grade, selectedSession, gradesBySession } = this.state;
        let gList=[];
        const _grades=(gradesBySession).map(g=>g.value);
        if(selectedSession==='All' && grade=='All'){
          gList=[];
        }
        else if(selectedSession!=='All' &&  grade=='All'){
          gList= _grades;
        }else{
            gList.push(grade);
        }
        return gList
      }
      sendReport = () => {
            if((this.state.catererEmail||'').trim()!=''){
                if(this.state.viewBy==='Day_Items'){
                    if(this.state.filterBy==='Weekly'){
                        this.getCatererReport_ByDay_Items(this.state.startDate, this.state.endDate, true, 'Email');
                        }else{
                            this.getCatererReport_ByDay_Items(this.state.mStartDate, this.state.mEndDate, true, 'Email');
                        }
                }else{
                    this.getCatererReportPdf('Email');
                }
            }        
        }
      getCatererReportPdf = (type) => {
        const filterGrades=this.filterGradesBySelection();
        const _props=this;
	    this.setState({loading: true});
        let startDate= this.state.filterBy==catererView.month?moment(this.state.mDate).startOf('month'):
        moment(this.state.date).startOf('week');
        let endDate= this.state.filterBy==catererView.month?moment(this.state.mDate).endOf('month'):
        moment(this.state.date).endOf('week');
        let byItem=(this.state.viewBy==catererFilterView.items)?true:false;
        if(this.state.mealType===MealTypesReports.LUNCH || this.state.mealType===MealTypesReports.BREAKFAST ||
            this.state.mealType===MealTypesReports.SNACK){
       if(type=='Email'){
            let url=`/reports/catererExportReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}&menuType=${this.state.mealType}&fileType=Pdf&byItem=${byItem}&catererEmail=${this.state.catererEmail}&access_token=`;
            if(filterGrades.length>0){
                url=`/reports/catererExportReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&grades=${filterGrades.join(',')}&startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}&menuType=${this.state.mealType}&fileType=Pdf&byItem=${byItem}&catererEmail=${this.state.catererEmail}&access_token=`;
            }
            get(url).then((response) => {
                if (!response.ok) {
                    if(response.status===417){
                        return response.json();
                    }else{              
                        throw Error(response.statusText);
                    }                    
                }
                return response.json();                
            }).then(resp=>{
                if (resp.statusCode === 417) {
                    _addNotificationError(resp.statusMessage,this);
                    throw Error(resp.statusMessage);
                }else{
                    return resp
                }
            }).then(data => { 
                if(data.statusCode==200){
                    _addNotification(data.statusMessage,_props);
                    this.setState({openCatererModal:false, catererEmail:'', loading:false});
                }else{
                    _addNotification(data.errorMessage,_props);
                    this.setState({openCatererModal:false, catererEmail:'', loading:false});
                }
                                 
            }).catch(error => {
                //_addNotification(error,_props);
                this.setState({openCatererModal:false, catererEmail:'', loading:false});
            });
        }else{
            if(this.state.viewBy==='Day_Items'){
                this.getCatererReport_ByDay_Items(startDate,endDate, true);
                return;
            }

            let url=`/reports/catererExportReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}&menuType=${this.state.mealType}&fileType=Pdf&byItem=${byItem}&access_token=`;
            if(filterGrades.length>0){
                url=`/reports/catererExportReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&grades=${filterGrades.join(',')}&startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}&menuType=${this.state.mealType}&fileType=Pdf&byItem=${byItem}&access_token=`;
            }
            get(url).then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }else{
                    throw Error(response.statusText);
                    }
                }		        
                return response;                
            }).then(resp=>{
                this.setState({loading: false});
                if (resp.statusCode === 417) {
                     _addNotificationError(resp.statusMessage,this);
                     throw Error(resp.statusMessage);
                }else{
                    return resp.blob();
                }
            }).then(blob => {
                
                    let filename = "Caterer Reports for " /* + (grade === 0 ? 'all grades' : 'grade-' + grade) */;
        
                    //if (fileType === "Pdf") {
                    // download(blob,filename + '.pdf', "pdf");
                    showFile(blob,filename);
                    //}
                /*  else {
                        download(blob,
                            filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    } */
                
            }).catch(error => {
		        this.setState({loading: false});
                console.log("Download Failed", error)
            });
        }}
    };
    render() {
        const {filterBy,viewBy, mealType, date, mDate, startDate, endDate, openCatererModal,
        selectedSession, gradesBySession, grade, mStartDate,mEndDate, byDayItemsData }=this.state;
        const sessionList=getSchoolSessions(0,false);
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <TmExportExcel id="catererExcel" 
                        name={"Caterer report"}
                        filename={"Caterer Report"}
                        element={<button className="btn btn-warning btn-xs pull-right" id='btnCatererReportExport' style={{margin:'4px', display:'none'}}>
                        <i className="fa fa-file-excel-o"></i> Export</button>}
                        dataSet={this.buildDataFormatForExport()}
                    />
                <div className="pull-right" style={{display:'inline-block',marginLeft: '50px'}}>                    
                    <MenuOptions menuOptionsList={getReportMenuOptions()} onOptionSelect={(type)=>{
                        this.setState({mealType:type},()=>{
                            if(viewBy==='Day_Items'){
                                this.getCatererReport_ByDay_Items(startDate,endDate, false);
                            }else{
                            if(filterBy==='Weekly'){
                            this.getCatererReport(startDate,endDate);
                            }else{
                                this.getCatererReport(mStartDate,mEndDate);
                            }
                        }})
                    }} selectedOption={(this.state.mealType)} />
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        <label style={{
                            padding: '5px 0px 0px 10px',
                            fontWeight: '700',
                        }}>{`${filterBy} ${mealType===MealTypesReports.LUNCH? (isRegularLunchOrderType() ?'Lunch Caterer Report':'Al a Carte Caterer Report'): mealType===MealTypesReports.SNACK ?'Snack Caterer Report': mealType===MealTypesReports.BREAKFAST ?'Breakfast Caterer Report' :  mealType===MealTypesReports.DINNER ? 'Dinner Caterer Report' : ' '}`}</label>
                    </div>
                    <div className="col-xs-4" style={{ textAlign: 'center' }}>
                        {filterBy == 'Weekly' ? 
                            <CalenderCarousel type={"Week"} date={moment(date)} 
                            startDate={moment(startDate)} endDate={moment(endDate)} 
                            dateChange={({start,end, cDate})=>{
                                const _start=moment(start);
                                const _end=moment(end);
                                this.setState({startDate:start,endDate:end,date:cDate},()=>{
                                    if(viewBy==='Day_Items'){
                                        if(filterBy==='Weekly'){
                                            this.getCatererReport_ByDay_Items(_start,_end);
                                            }}else{
                                    this.getCatererReport(_start,_end);
                             } })
                            }} /> : 
                            <CalenderCarousel type={"Month"} date={moment(mDate)} startDate={moment(mStartDate)} endDate={moment(mEndDate)} 
                            dateChange={({start,end, cDate})=>{
                                const _start1=moment(start);
                                const _end1=moment(end);
                                this.setState({mStartDate:_start1,mEndDate:_end1,mDate:_start1},()=>{
                                    if(viewBy==='Day_Items'){
                                        if(filterBy==='Monthly'){
                                        this.getCatererReport_ByDay_Items(_start1,_end1, false);
                                    }}else{
                                    this.getCatererReport(_start1,_end1);
                                }})
                            }} />}
                    </div>
                </div>
                <div className="row" style={{paddingBottom:'5px'}}>
                    <div className="col-xs-3 text-right">
                        <div id="filteredBy" className="btn-group">
                            <button id="Week" type="button" className={filterBy=== "Weekly"? "btn btn-xs btn-inactive-color active":"btn btn-xs btn-inactive-color"}
                                onClick={() => {                                 
                                    this.setState({ filterBy: "Weekly" },()=>{
                                        this.setWeek();
                                }) }}
                                style={{ margin: 0, marginLeft: 5, fontSize: 14 }}
                            >Week </button>
                            <button id="Month" type="button" className={filterBy=== "Monthly"?"btn btn-xs btn-inactive-color active":"btn btn-xs btn-inactive-color"}
                                onClick={() => { this.setState({ filterBy: "Monthly" },()=>{
                                    this.setMonth();
                                }) }}
                                style={{ margin: 0, marginLeft: 5, fontSize: 14 }}
                            >Month </button>
                        </div>
                    </div>
                    <div className="col-xs-2">
                        <select className="form-control" id={"selectBy"} value={viewBy}
                            onChange={(e) => {
                                const _viewBy=e.target.value
                                this.setState({ viewBy: e.target.value },()=>{
                                if(_viewBy==='Day_Items'){
                                    if(filterBy==='Weekly'){
                                        this.getCatererReport_ByDay_Items(startDate,endDate);
                                        }else{
                                            this.getCatererReport_ByDay_Items(mStartDate,mEndDate);
                                        }
                                }else{
                                if(filterBy==='Weekly'){
                                    this.getCatererReport(startDate,endDate);
                                    }else{
                                        this.getCatererReport(mStartDate,mEndDate);
                                    }
                                }})}
                                }>
                            <option value={"Day"}>By Day</option>
                            <option value={"Items"}>By Items</option>
                            <option value={"Day_Items"}>By Day & Items</option>
                        </select>
                    </div>
                    <div className="col-md-6 text-left">
                        <form className="form-inline">
                            <div className="form-group" style={{paddingRight:'5px'}}>
                                <label htmlFor="selectedSession" style={{paddingRight:'5px'}}>Sessions: </label>
                                <select className="form-control" 
                                    id={"selectedSession"} value={selectedSession}
                                        onChange={(e) => {
                                        this.setState({ selectedSession: e.target.value, dayGrade:'All',weekGrade:'All' },()=>{                                            
                                            this.bindGradeListBySession();
                                                                                                                            
                                        })}}>
                                    <option value={"All"}>All</option>
                                        {
                                        sessionList.map((session,i)=>{
                                            return <option key={i}>{session.session}</option>
                                        })                          
                                        }
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="selectBy" style={{paddingRight:'5px'}}>Grades: </label>
                                <select className="form-control" id={"selectBy"} value={grade}
                                        onChange={(e) => {
                                            this.setState({ grade: e.target.value },()=>{
                                                if(viewBy==='Day_Items'){
                                                    if(filterBy==='Weekly'){
                                                        this.getCatererReport_ByDay_Items(startDate,endDate, false);
                                                        }else{
                                                            this.getCatererReport_ByDay_Items(mStartDate,mEndDate, false);
                                                        }
                                                }else{
                                                if(filterBy==='Weekly'){
                                                    this.getCatererReport(startDate,endDate);
                                                    }else{
                                                        this.getCatererReport(mStartDate,mEndDate);
                                                    }
                                            }});
                                        }}>
                                        <option value={"All"}>All</option>
                                        {(gradesBySession||[]).map((item)=> {
                                        return <option
                                            value={item.value}>{item.label}</option>
                                        }, this)}
                                </select>
                            </div>
                        </form>
                    </div>
                </div>
                    <div className="row">
                    {
                        (filterBy == 'Weekly' && viewBy == 'Day') ?
                            this.bindWeekDataTable()
                        : 
                        (filterBy == 'Monthly' && viewBy == 'Day') ? 
                            this.bindMonthDataTable():
                        (viewBy == 'Day_Items') ? 
                            this.bindByDayItemTable():
                            this.bindWeekItemWiseTable()                            
                        }
                    </div>
                    <Modal
                    isOpen={openCatererModal}
                    onRequestClose={() => this.setState({ openCatererModal: false })}
                    style={deleteStyles} ariaHideApp={false}
                    contentLabel="Share Report">

                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Send Report</h4>
                    </div>
                    <div className="modal-body">
                        <div>
                            <label style={{ margin: '10px' }}>Caterer Email:</label>
                            <input style={{ display: 'inline-block' }} value={this.state.catererEmail}
                            type="email" onChange={(e) => this.handleChange(e)} />
                            {this.state.error && <div style={{color: 'red'}}>{this.state.error}</div>}
                        </div>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => this.setState({ openCatererModal: false, catererEmail:'' })}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                        <button type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} onClick={() => { this.sendReport() }}
                            id="deleteConfirm" disabled={(this.state.error)?true:false}><i className="glyphicon glyphicon-ok"></i> Send
                                    </button>
                    </div>
                </Modal>
            </Fragment>
        );
    }
}

export default CatererReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/AdminReports/CatererReport/catererReport.jsx